export default class EmailValidationInitializationError extends Error {}
